export default __webpack_public_path__ + "static/media/facebook_icon.ddccf8c3.png";